import PropTypes from "prop-types";

export const ProjectAdditionalCostType = {
  id: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  estimated_cost: PropTypes.number,
  description: PropTypes.string,
};

export const ProjectWithCostsType = {
  id: PropTypes.number,
  additional_costs: PropTypes.arrayOf(
    PropTypes.shape(ProjectAdditionalCostType)
  ),
  interventions_cost: PropTypes.number,
  total_cost: PropTypes.number,
  estimated_total_cost: PropTypes.number,
};

export const ProjectCostItemType = {
  name: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  color: PropTypes.string,
};
